export const cheatcodesStackNavigatorPathConfig = {
  CheatcodesStackNavigator: {
    screens: {
      CheatcodesMenu: 'cheatcodes',
      CheatcodesNavigationAccountManagement: 'cheatcodes/other/account-management',
      CheatcodesNavigationAchievements: 'cheatcodes/achievements',
      CheatcodesNavigationBirthdayNotifications: 'cheatcodes/birthday-notifications',
      CheatcodesNavigationBookings: 'cheatcodes/bookings',
      CheatcodesNavigationBookOffer: 'cheatcodes/book-offer',
      CheatcodesNavigationBonification: 'cheatcodes/bonification',
      CheatcodesNavigationCulturalSurvey: 'cheatcodes/cultural-survey',
      CheatcodesNavigationErrors: 'cheatcodes/other/errors',
      CheatcodesNavigationForceUpdate: 'cheatcodes/other/force-update',
      CheatcodesNavigationGenericPages: 'cheatcodes/other/generic-pages',
      CheatcodesNavigationHome: 'cheatcodes/home',
      CheatcodesNavigationIdentityCheck: 'cheatcodes/identity-check',
      CheatcodesNavigationInternal: 'cheatcodes/internal',
      CheatcodesNavigationNewIdentificationFlow:
        'cheatcodes/identity-check/new-identification-flow',
      CheatcodesNavigationNotScreensPages: 'cheatcodes/other/not-screens-pages',
      CheatcodesNavigationOnboarding: 'cheatcodes/onboarding',
      CheatcodesNavigationProfile: 'cheatcodes/profile',
      CheatcodesNavigationProfileTutorial: 'cheatcodes/tutorial/profile-tutorial',
      CheatcodesNavigationShare: 'cheatcodes/share',
      CheatcodesNavigationSignUp: 'cheatcodes/other/sign-up',
      CheatcodesNavigationSubscription: 'cheatcodes/subscription',
      CheatcodesNavigationTrustedDevice: 'cheatcodes/trusted-device',
      CheatcodesNavigationTutorial: 'cheatcodes/tutorial',
      CheatcodesScreenAccesLibre: 'cheatcodes/other/acces-libre',
      CheatcodesScreenBookingNotFound: 'cheatcodes/bookings/booking-not-found',
      CheatcodesScreenCategoryThematicHomeHeader: 'cheatcodes/home/category-thematic-home-header',
      CheatcodesScreenDebugInformations: 'cheatcodes/other/debug-informations',
      CheatcodesScreenDefaultThematicHomeHeader: 'cheatcodes/home/default-thematic-home-header',
      CheatcodesScreenFeatureFlags: 'cheatcodes/other/feature-flags',
      CheatcodesScreenGenericErrorPage: 'cheatcodes/other/generic-error-page',
      CheatcodesScreenGenericInfoPage: 'cheatcodes/other/generic-info-page',
      CheatcodesScreenGenericOfficialPage: 'cheatcodes/other/generic-official-page',
      CheatcodesScreenHighlightThematicHomeHeader: 'cheatcodes/home/highlight-thematic-home-header',
      CheatcodesScreenLayoutExpiredLink: 'cheatcodes/other/layout-expired-link',
      CheatcodesScreenMaintenance: 'cheatcodes/maintenance',
      CheatcodesScreenMandatoryUpdate: 'cheatcodes/other/campagne-mise-a-jour-données',
      CheatcodesScreenNewCaledonia: 'cheatcodes/other/new-caledonia',
      CheatcodesScreenNotEligibleEduConnect: 'cheatcodes/identity-check/not-eligible-educonnect',
      CheatcodesScreenPageWithHeader: 'cheatcodes/other/page-with-header',
      CheatcodesScreenRemoteBanners: 'cheatcodes/remote-banners',
      CheatcodesScreenRemoteConfig: 'cheatcodes/other/remote-config',
      CheatcodesScreenSecondaryPageWithBlurHeader:
        'cheatcodes/other/secondary-page-with-blur-header',
      CheatcodesScreenTrustedDeviceInfos: 'cheatcodes/trusted-device/trusted-device-infos',
    },
  },
}
